import { ChangeContractDurationValidatorErrors } from '../types';

export const defaultChangeContractDurationError: ChangeContractDurationValidatorErrors = {
    newContractDuration: {
        sameAsPrevious: 'Contract duration must be changed',
    },
};
